import router from './router'
import { useUserStore } from '@/store/modules/user'
import common from '@/utils/common' 
import Cookies from 'js-cookie'
 
// 区分美吉、桑格
const {
  VITE_APP_MJ_KF_ORIGIN,
  VITE_APP_SG_KF_ORIGIN,
  VITE_APP_MJ_CLOUD_ORIGIN,
  VITE_APP_SG_CLOUD_ORIGIN
} = import.meta.env

let kfOrigin = ''
let cloudOrigin = ''

if (common.getWebName() === 'mj' || common.getWebName() === 'local') {
  kfOrigin = VITE_APP_MJ_KF_ORIGIN
  cloudOrigin = VITE_APP_MJ_CLOUD_ORIGIN
} else if (common.getWebName() === 'sg') {
  kfOrigin = VITE_APP_SG_KF_ORIGIN
  cloudOrigin = VITE_APP_SG_CLOUD_ORIGIN
}


// 加载当前模式下的环境变量
const NODE_ENV = import.meta.env.VITE_APP_ENV
 
const whiteList = ['/project-center/download','/project-center/question'] // 免登录白名单

router.beforeEach(async (to, from, next) => {

  // 从路由的meta中获取title
  const title = to.meta.title
  if (title) {
    document.title = title
  }


  let previousPageUrl = document.referrer
 
  if ((previousPageUrl.indexOf(cloudOrigin) !== -1 ||
    previousPageUrl.indexOf(kfOrigin) !== -1) && from.fullPath === '/') { 
    // 免密登录进来的
    sessionStorage.removeItem('defaultAddressTemp')
    localStorage.removeItem('extraContact')
    Cookies.remove('panMajorbioVisible')
    Cookies.remove('contractReadVisible')
    console.log('删除cookie1')
  }
  sessionStorage.setItem('toFullPath', `${to.href}`) // 记录上一个页面地址，用来配合index.html页面的自动更新逻辑
  // 派发自定义事件，附带路由信息
  document.dispatchEvent(
    new CustomEvent('route-change', { detail: { path: to.fullPath } })
  )
  
  let sso = Cookies.get('sso')
  if (sso) { // 通过sso进行登录
    common.setCache('token', sso) 
      // 判断是否有sso
      try {
        // pinia使用
        const userStore = useUserStore()
        // 缓存用户信息
        if (window.location.pathname !== '/project-center/download') {
          userStore.setUserInfo()
        }
        next()
      } catch (error) {
        // 跳转到登录页
        if (NODE_ENV === 'local') { // 本地环境
          return
        } else { // 其他环境（测试、预发、生产）
          // ElMessage({
          //   message: '您已登录失效，请重新登录',
          //   type: 'error',
          //   showClose: true,
          //   duration:1500
          // });
          // setTimeout(() => { 
            window.location.href = `${kfOrigin}/web/login/passport/login-email?redirect_url=${window.location.href}`
          // },1500)
        }
      }
    // }
  } else { // 拿不到sso，说明还未登录，需要做登录处理
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单里,直接进入
      next()
    } else {
      // 跳转到登录页
      if (NODE_ENV === 'local') { // 本地环境
        return
      } else  { // 其他环境（测试、预发、生产）
        // ElMessage({
        //   message: '您已登录失效，请重新登录',
        //   type: 'error',
        //   showClose: true,
        //   duration:1500
        // });
        // setTimeout(() => { 
          window.location.href = `${kfOrigin}/web/login/passport/login-email?redirect_url=${window.location.href}`
        // },1500)
      }
    }
  }
})

router.afterEach((to, from) => {
  // 页面跳转后，自动关闭聊天窗口（scx中的代码）
  window.parent && window.parent.postMessage && window.parent.postMessage({ type: 'closeChat' }, "*")
})
